<template>
  <div class="productDetailTab">
    <div class="detail_section" v-if="!$route.path.includes('/product-deal')">
      <PrdtName
        :dataName="allDetails"
        :showDiscountSnackbar="isShowSnackbar"
        :finalAmount="allDetails.sellingPrice"
        :cutAmountStyle="dataStyleAmount"
        :dispalyRatingVal="dataAvgRating"
      />
    </div>
    <div
      class="limited_offer"
      v-if="
        allDetails.displayMessageDTOs && allDetails.displayMessageDTOs.length
      "
    >
      <div
        v-for="(item, index) in allDetails.displayMessageDTOs"
        class="offer-display"
        :key="index"
      >
        <span class="msg_offer_time">{{ item.dealDisplayMessage }}</span>
        <Timer
          :timing="getLiveTime(item.dealEndTimeMillis)"
          v-if="item.dealEndTimeMillis"
        />
      </div>
    </div>
    <OyeLuckyLuckyOye
      :dataOyeLucky="allDetails"
      :colorBasedCutPrice="priceBasedCutData"
      v-if="allDetails.oyeLuckyEnabled"
    />
    <CutThePrice
      :dataCutThePrice="allDetails"
      @applycutprice="applycutprice"
      :colorBasedCutPrice="priceBasedCutData"
    />
    <!-- <div class="detail_section" v-if="$cookie.get('version-code') > 100">
      <OffersList :dataShareAndEarn="allDetails" />
    </div> -->
    <div
      class="detail_section"
      v-if="
        allDetails.selectableAttributes != null &&
        (allDetails.selectableAttributes.SIZE ||
          allDetails.selectableAttributes.COLOR)
      "
    >
      <Color
        @saleReferenceID="saleReference_id"
        @ProductColor="ItemColor"
        @ProductSize="ItemSize"
        @Stock="StockData"
        @getItemWiseValue="getItemWiseValue"
        :dataColor="allDetails"
        @PRODUCTDETAILAFFTERSELECTION="getNewDetailvalueAfterSelection"
        @CutPriceEnable="isCutPriceEnable"
      />
    </div>
    <div
      class="detail_section"
      v-if="parseFloat(allDetails.codPartialPaymentPercentage) > 0"
      style="
        color: rgb(0, 145, 255);
        font-size: 0.75em;
        text-shadow: 0px 1px #4a5c6af5;
      "
    >
      In case of COD, you have to pay
      {{ allDetails.codPartialPaymentPercentage }}% amount in advance.
    </div>
    <!-- <div
      class="detail_section"
      v-if="allDetails.itemAttributeDTOList && allDetails.itemAttributeDTOList.length">
      <DisplayColorSize
        @saleReferenceID="saleReference_id"
        @ProductColor="ItemColor"
        @ProductSize="ItemSize"
        @Stock="StockData"
        :dataColor="allDetails"
        @CutPriceEnable="isCutPriceEnable"
      />
    </div> -->
    <div
      class="detail_section"
      v-if="parseFloat(allDetails.cashBackAmount) > 0"
    >
      <p class="wish-bar">
        Min Order of Rs. {{ parseFloat(allDetails.minOrderAmount) }} Get Rs.
        {{ parseFloat(allDetails.cashBackAmount) }} Cashback on order Delivery
      </p>
    </div>
    <div
      class="detail_section"
      :class="{
        'detail-seller-section': $route.path.includes('/product-deal'),
      }"
    >
      <SellerListing
        :sellerDetails="allDetails"
        @addToBagFunc="addToCartFuncEmit"
        :addToCartValue="addToCart"
        @getUserLocation="getLocationCall"
        @buyNowFunc="buyNowFuncEmit"
        :colorValue="this.color"
        :sizeValue="this.size"
        @notLoggedInUser="checkUserIsLogin"
      />
    </div>
    <!-- <div class="detail_section share_section" style="border: 0;
    margin-top: -8px;">
    <ShareAndEarn
        :dataShareAndEarn="allDetails"
        v-if="!allDetails.cutPriceEnable && !allDetails.oyeLuckyEnabled"
      />
    </div> -->
    <div
      class="detail_section"
      :class="{ 'detail-qty-section': $route.path.includes('/product-deal') }"
    >
      <Quantity :dataQuantity="allDetails" @getItemQuantity="ItemQuantity" />
    </div>

    <div class="apply-offer-blk" v-if="$route.path.includes('/product-deal')">
      <h2>Apply M91 Rewards</h2>
      <p>
        Use upto {{ allDetails.maxM91RewardDealDiscount * orderableQuantity }}
        M91 Rewards to reduce price
      </p>
      <div class="apply-input-blk">
        <input
          type="number"
          name=""
          v-model="applyReward"
          placeholder="Enter M91 Rewards..."
          class="input-apply"
        />

        <span class="apply-btn" id="applyBtn" @click="applyRewardBtn()"
          >Apply</span
        >
      </div>
      <div class="price-block">
        <div style="display: flex">
          Discounted Price : &nbsp;
          <div class="prdt-price new-price">
            ₹{{
              orderedQuantityPrice !== ""
                ? orderedQuantityPrice
                : applyRewardPrice == ""
                ? allDetails.sellingPrice * orderableQuantity
                : applyRewardPrice
            }}
          </div>
        </div>
        <div>
          Price :
          <strike>₹{{ allDetails.sellingPrice * orderableQuantity }}</strike>
        </div>
        <div style="display: flex; margin-top: 5px">
          MRP : &nbsp;
          <div class="prdt-price old-price">
            ₹{{ allDetails.mrp * orderableQuantity }}
          </div>
        </div>
      </div>
    </div>

    <div class="detail_section" v-if="!$route.path.includes('/product-deal')">
      <AboutProduct :dataAbtPrd="allDetails" />
    </div>

    <div class="detail_section" v-if="allDetails.gmallProductId">
      <ProductPolicy :productPolicy="allDetails" />
    </div>
    <div v-if="!$route.path.includes('/product-deal')">
      <div class="detail_section flx" v-if="allDetails.sellerLiteDTO">
        <!-- <div class="shop-detail" style="width:100%"> -->
        <!-- <h6 class="prdt_sub_hdng">
        <span class="heading">{{$t('shopName')}}  -</span>
        <span class="detail">{{allDetails.sellerLiteDTO.storeName}}</span>
      </h6>
      <h6 class="prdt_sub_hdng" v-if="allDetails.sellerLiteDTO.sellerShopAddress">
        <span class="heading">{{$t('shopAddress')}}  -</span>
        <span class="detail">{{allDetails.sellerLiteDTO.sellerShopAddress.address}}, {{allDetails.sellerLiteDTO.sellerShopAddress.city}}, {{allDetails.sellerLiteDTO.sellerShopAddress.zipCode}}</span>
      </h6> -->
        <h6 class="prdt_sub_hdng">
          <span class="heading">Country -</span>
          <span class="detail"><strong>INDIA</strong></span>
        </h6>
        <!-- </div> -->
      </div>
    </div>

    <div class="order_button" v-if="inStock" style="display: none">
      <div class="new_buy_button">
        <div>
          <span class="price">
            <span class="ruppee-sign">₹</span>
            {{ allDetails.sellingPrice }}
          </span>
          <span>
            <strike>₹{{ allDetails.mrp }}</strike>
          </span>
        </div>
        <div class="deal-item-added">
          <button
            type="button"
            class="large_group_btn group"
            @click="addToCartFunc('addTocart')"
            :class="{ 'product-added': addToCart }"
          >
            <span>Add to Bag</span>
          </button>
        </div>
      </div>
    </div>
    <div class="order_button" v-if="inStock == false" style="display: none">
      <button
        type="button"
        class="large_green_btn order_on_chat"
        @click="viaPaytmCashCall('online')"
        style="pointer-events: none; padding: 18px"
      >
        {{ $t("outOfStock") }}
      </button>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />

    <div class="ftr-btn-blk">
      <div class="button-block">
        <span
          class="button"
          @click="addToBag(allDetails.sellerItemRelationshipId)"
          >Buy Now</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import constant from "../../utils/constant";
import PrdtName from "../ProductDetailSection/ProductDetailTab/PrdtName";
import Color from "../ProductDetailSection/ProductDetailTab/Color";
import OffersList from "../ProductDetailSection/ProductDetailTab/OffersList";
import DisplayColorSize from "../ProductDetailSection/ProductDetailTab/DisplayColorSize";
import Quantity from "../ProductDetailSection/ProductDetailTab/Quantity";
import AboutProduct from "../ProductDetailSection/ProductDetailTab/AboutProduct";
import ShareAndEarn from "../ProductDetailSection/ProductDetailTab/ShareAndEarn";
import ProductPolicy from "../ProductDetailSection/ProductDetailTab/ProductPolicy";
import SellerListing from "../ProductDetailSection/ProductDetailTab/SellerListing";
import ProductCard from "../HomeSection/ProductCard";
import GroupList from "../ProductDetailSection/ProductDetailTab/GroupList";
import CustomToaster from "../Common/CustomToaster";
import CutThePrice from "../ProductDetailSection/ProductDetailTab/CutThePrice";
import OyeLuckyLuckyOye from "../ProductDetailSection/ProductDetailTab/OyeLuckyLuckyOye";
import Timer from "../../components/Common/TimeCount";
import ApiCaller from "../../utils/apicaller";
import types from "../../store/types";
export default {
  name: "ProductDetailTab",
  props: {
    dataValue: {
      required: true,
      type: Object,
    },
    dataStyleAmount: {
      type: Boolean,
    },
    dataAvgRating: {
      type: Object,
    },
    dataValueInStock: {
      type: Boolean,
    },
    itemAddedValue: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["cartSize"]),
  },
  components: {
    PrdtName,
    Color,
    DisplayColorSize,
    Quantity,
    AboutProduct,
    ShareAndEarn,
    ProductPolicy,
    SellerListing,
    ProductCard,
    GroupList,
    CutThePrice,
    OyeLuckyLuckyOye,
    Timer,
    CustomToaster,
    OffersList,
  },
  data() {
    return {
      adDiscount: "",
      saleReferenceID: null,
      loading: false,
      categoryId: 0,
      pageIndex: 0,
      allDetails: {},
      colorDetails: {},
      sizeDetails: [],
      buttonMsg: "27%",
      color: null,
      size: null,
      xauthid: this.$cookie.get("X-Auth-Id"),
      displayTimeText: "",
      isShowSnackbar: false,
      ApiType: "createPreOrderAgain",
      isToasterData: false,
      toasterData: {},
      priceBasedCutData: {},
      inStock: false,
      showAdButton: false,
      addToCart: false,
      orderableQuantity: 1,
      orderSourceType: null,
      displayMessageDTOs: [],
      applyReward: "",
      isApplyReward: "",
      applyRewardPrice: "",
      orderedQuantityPrice: "",
    };
  },
  watch: {
    dataValue() {
      var _this = this;
      this.allDetails = this.dataValue;
      if (this.allDetails) {
        this.applyReward = this.allDetails.maxM91RewardDealDiscount;
        document.getElementById("applyBtn").click();
        if (this.allDetails.dealDisplayMessage) {
          this.isShowSnackbar = false;
        } else {
          this.isShowSnackbar = true;
        }
        this.$cookie.set("ProductId", this.allDetails.productId);
        this.categoryId = this.allDetails.categoryId;
        this.buttonMsg = `${this.allDetails.onlineDiscount} ₹​ अतिरिक्त छूट`;
      }
    },
    dataValueInStock() {
      this.inStock = this.dataValueInStock;
    },
    orderableQuantity() {
      if (
        this.allDetails.maxM91RewardDealDiscount * this.orderableQuantity <
        this.applyReward
      ) {
        this.toasterData = {
          msg: `You can apply upto ${
            this.allDetails.maxM91RewardDealDiscount * this.orderableQuantity
          } M91 Rewards to reduce price`,
          color: "#e51c24",
          iconName: "error",
        };
        this.isToasterData = true;
      } else {
        this.orderedQuantityPrice =
          this.applyReward !== ""
            ? this.allDetails.sellingPrice * this.orderableQuantity -
              this.applyReward
            : this.allDetails.sellingPrice * this.orderableQuantity;
      }
    },
  },
  methods: {
    buyNowProductDeal() {
      this.loading = true;
      let payloadObj = {
        m91RewardDealDiscount: this.applyReward,
        orderedQuantity: this.orderableQuantity,
        sellerItemRelationshipId: this.allDetails.sellerItemRelationshipId,
        paymentMethod: "PAYTM",
        price:
          this.orderedQuantityPrice !== ""
            ? this.orderedQuantityPrice
            : this.applyRewardPrice !== ""
            ? this.applyRewardPrice
            : this.allDetails.sellingPrice,
      };
      this.$store.commit("SET_BUY_DETAILS", payloadObj);
    },
    applyRewardBtn() {
      this.orderedQuantityPrice = "";
      if (this.applyReward == "") {
        this.applyRewardPrice =
          this.allDetails.sellingPrice * this.orderableQuantity;
      } else if (
        parseFloat(this.applyReward) <=
        this.allDetails.maxM91RewardDealDiscount * this.orderableQuantity
      ) {
        this.applyRewardPrice =
          this.allDetails.sellingPrice * this.orderableQuantity -
          this.applyReward;
      } else {
        this.toasterData = {
          msg: `You can apply upto ${
            this.allDetails.maxM91RewardDealDiscount * this.orderableQuantity
          } M91 Rewards to reduce price`,
          color: "#e51c24",
          iconName: "error",
        };
        this.isToasterData = true;
      }
    },

    addToBag(sellId) {
      if (
        this.allDetails.selectableAttributes.COLOR &&
        this.allDetails.selectableAttributes.COLOR.length > 1
      ) {
        if (this.color == null) {
          console.log(this.color);
          this.toasterData = {
            msg: this.$t("pleaseSelectColor"),
            color: "#e51c24",
            iconName: "error",
          };
          this.isToasterData = true;
          return;
        }
      }
      if (
        this.allDetails.selectableAttributes.SIZE &&
        this.allDetails.selectableAttributes.SIZE.length > 1
      ) {
        console.log("this.size", this.size);
        if (this.size == null) {
          this.toasterData = {
            msg: this.$t("pleaseSelectSize"),
            color: "#e51c24",
            iconName: "error",
          };
          this.isToasterData = true;
          return;
        }
      }
      if (
        this.allDetails.sellerItems &&
        this.allDetails.sellerItems.length > 1
      ) {
        this.openSellerList = !this.openSellerList;
      } else {
        if (this.$cookie.get("JWT-TOKEN")) {
          //TODO remove unused code
          if (
            this.allDetails.maxM91RewardDealDiscount * this.orderableQuantity <
            this.applyReward
          ) {
            this.toasterData = {
              msg: `You can apply upto ${
                this.allDetails.maxM91RewardDealDiscount *
                this.orderableQuantity
              } M91 Rewards to reduce price`,
              color: "#e51c24",
              iconName: "error",
            };
            this.isToasterData = true;
          } else {
            this.buyNowProductDeal();
            this.$router.push("/cart-check-out");
            // this.viaPaytmCashCall("buyNowOption", sellId);
            try {
              JSBridgePlugin.fireEvents("Local91_Item_Add_To_Bag");
            } catch (err) {
              console.log(err);
            }
          }
        } else {
          this.$emit("notLoggedInUser");
        }
      }
    },

    getLocationCall() {
      this.$emit("getUserLocationCallBack");
    },
    getNewDetailvalueAfterSelection(value) {
      this.$emit("setNewDetailValue", value);
    },
    checkUserIsLogin() {
      this.$emit("notLoggedInUser");
    },
    addToCartFuncEmit(sellId) {
      try {
        JSBridgePlugin.fireEvents("Local91_Item_Add_To_Bag");
      } catch (err) {
        console.log(err);
      }
      this.viaPaytmCashCall("addTocart", sellId);
    },
    buyNowFuncEmit(sellId) {
      try {
        JSBridgePlugin.fireEvents("Local91_Item_Add_To_Bag");
      } catch (err) {
        console.log(err);
      }
      this.viaPaytmCashCall("buyNowOption", sellId);
    },

    addToCartFunc(value) {
      try {
        JSBridgePlugin.fireEvents("Item_Add_To_Bag");
      } catch (err) {
        console.log(err);
      }
      this.viaPaytmCashCall(value);
    },
    isCutPriceEnable(cutPriceObj) {
      this.priceBasedCutData = cutPriceObj;
    },
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (this.liveData.length > 0) {
        this.liveData[obj.index].status = false;
      }
    },
    applycutprice(cuttheprice_boolean) {
      this.$emit("ENABLACUTPRICE", cuttheprice_boolean);
    },
    StockData(obj) {
      this.inStock = obj.stock;
      this.allDetails.sellingPrice = obj.sellingPrice;
      this.allDetails.mrp = obj.mrp;
    },
    getItemWiseValue(obj) {
      this.$emit("updatedPrice", obj);
    },
    ItemColor(color) {
      this.color = color;
    },
    ItemQuantity(quantity) {
      this.orderableQuantity = quantity;
    },
    saleReference_id(value) {
      this.saleReferenceID = value;
    },
    ItemSize(size) {
      this.size = size;
    },

    buyInGroup(productId, saleId) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        if (
          this.allDetails.selectableAttributes.COLOR &&
          this.allDetails.selectableAttributes.COLOR.length > 0
        ) {
          if (this.color == null) {
            this.toasterData = {
              msg: this.$t("pleaseSelectColor"),
              color: "#e51c24",
              iconName: "error",
            };
            this.isToasterData = true;
            return;
          }
        }
        if (
          this.allDetails.selectableAttributes.SIZE &&
          this.allDetails.selectableAttributes.SIZE.length > 0
        ) {
          if (this.size == null) {
            this.toasterData = {
              msg: this.$t("pleaseSelectSize"),
              color: "#e51c24",
              iconName: "error",
            };
            this.isToasterData = true;
            return;
          }
        }
        this.$router.push(
          "/group-list/?productId=" + productId + "&itemId=" + saleId
        );
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },

    viaPaytmCashCall(value, sellId) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true;
        if (this.$cookie.get("JWT-TOKEN")) {
          let cartObj;
          if (value === "online") {
            cartObj = {
              saleReferenceID: sellId,
              referralUserId: this.allDetails.encodedId,
              size: this.size,
              color: this.color,
              preOrderSource: "ONLINE_FORM",
              addToCart: false,
            };
          } else {
            console.log(
              this.allDetails,
              this.allDetails.sellerItemRelationshipId
            );
            cartObj = {
              sellerItemRelationshipId:
                sellId || Number(this.allDetails.sellerItemRelationshipId),
              orderedQuantity: this.orderableQuantity,
            };
            console.log(cartObj);
          }
          if (this.$route.query.source === "ADS_SERVER") {
            this.orderSourceType = this.$route.query.source;
          } else if (!this.$cookie.get("version-code")) {
            this.orderSourceType = "STORE_LOGIN";
          } else if (this.$route.query.source) {
            this.orderSourceType = this.$route.query.source;
          } else {
            this.orderSourceType = null;
          }
          let objectValue;
          if (
            sellId === this.allDetails.sellerItemRelationshipId &&
            this.$route.query.referralPayboardUserId
          ) {
            objectValue = `add-to-cart?orderSourceType=${this.orderSourceType}&referralPayboardUserId=${this.$route.query.referralPayboardUserId}`;
          } else if (
            this.$route.query.source &&
            this.$route.query.campaignIdentifier &&
            this.$route.query.campaignUnitIdentifier
          ) {
            objectValue = `add-to-cart?orderSourceType=${this.orderSourceType}&campaignIdentifier=${this.$route.query.campaignIdentifier}&campaignUnitIdentifier=${this.$route.query.campaignUnitIdentifier}`;
          } else if (
            this.$route.query.source &&
            this.$route.query.campaignIdentifier
          ) {
            objectValue = `add-to-cart?orderSourceType=${this.orderSourceType}&campaignIdentifier=${this.$route.query.campaignIdentifier}`;
          } else {
            objectValue = `add-to-cart?orderSourceType=${this.orderSourceType}`;
          }
          ApiCaller(constant.LOCAL_SHOP_URL_CART, objectValue, "post", cartObj)
            .then((data) => {
              this.loading = false;
              try {
                JSBridgePlugin.fireEvents("product_details_group_buy_click");
              } catch (err) {
                console.log(err);
              }
              if (value === "online") {
                if (this.$route.query.source) {
                  this.$router.push(
                    "/preOrderDetails/" +
                      data.data.preOrderId +
                      "?source=" +
                      this.$route.query.source
                  );
                } else {
                  this.$router.push("/preOrderDetails/" + data.data.preOrderId);
                }
              } else if (value === "addTocart") {
                this.addToCart = !this.addToCart;
                setTimeout(() => {
                  this.addToCart = !this.addToCart;
                  this.$emit("getProductAdded");
                  this.$store.commit(
                    types.UPDATE_CART_SIZE,
                    Math.round(parseInt(this.cartSize) + 1)
                  );
                }, 200);
                if (this.itemAddedValue) {
                  this.$router.push("/cart-check-out");
                }
              } else if (value === "buyNowOption") {
                this.$emit("getProductAdded");
                this.$store.commit(
                  types.UPDATE_CART_SIZE,
                  Math.round(parseInt(this.cartSize) + 1)
                );
                this.$router.push("/cart-check-out");
              } else {
                window.location.href = data.data.orderOnWhatsapp;
              }
            })
            .catch((err) => {
              if (
                err.response.data.errorCodes[0] == "PRODUCT_IS_OUT_OF_STOCK"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: "Item Out of Stock",
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] == "CART_SIZE_EXCEEDED"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t("cartSizeExceeded", { itemcount: "10" }),
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] == "ITEM_ALREADY_EXISTS_IN_CART"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t("itemAlreadyExist"),
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
                if (this.itemAddedValue) {
                  this.$router.push("/cart-check-out");
                }
              } else if (
                err.response.data.errorCodes[0] ==
                "MAX_ALLOWED_ORDER_LIMIT_REACHED"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t("orderLimitfull"),
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] ==
                "SINGLE_SELLER_ITEMS_ALLOWED_IN_CART"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: "एक बार में एक ही दूकान से आर्डर कर सकते हैं।",
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] == "MORE_QUANTITY_IN_CART"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t("orderLimitfull"),
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] ==
                "SHOP_ITEM_NOT_ALLOWED_WITH_MALL91_SUPPLY_ITEM"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t("canNotAddItemWithOtherShops"),
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] ==
                "ONLY_KIRANA_ITEM_ALLOWED_IN_CART"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: this.$t("onlyKiranaItemAllowedInCart"),
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] ==
                "ONLY_SINGLE_ITEM_ALLOWED_TO_ADD_FOR_COD_PARTIAL_PAYMENT"
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: "You can not add this item with current item in cart. Please complete your order first",
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] ==
                  "MAX_ALLOWED_QUANTITY_LIMIT_FOR_SKU_REACHED" &&
                this.allDetails.maxAllowedQuantityPerSku
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: `Can not add or order more than ${this.allDetails.maxAllowedQuantityPerSku} quantity of an item in a day`,
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.errorCodes[0] ==
                  "MAX_ALLOWED_QUANTITY_LIMIT_FOR_ALL_SKU_REACHED" &&
                this.allDetails.maxAllowedQuantity
              ) {
                this.loading = false;
                this.toasterData = {
                  msg: `Can not add or order more than ${this.allDetails.maxAllowedQuantity} quantity per day`,
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
              } else if (
                err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
                err.response.data.message ==
                  "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
              ) {
                try {
                  _JWT.refereshToken = (res) => {
                    if (res != "fail") {
                      this.$cookie.set("JWT-TOKEN", res);
                      this.ApiType = "createPreOrderAgain";
                      this.viaPaytmCashCall(value);
                    } else {
                      this.loading = false;
                    }
                  };
                  JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                } catch (err) {
                  this.loading = false;
                  this.$emit("notLoggedInUser");
                  console.log(err);
                }
              } else {
                console.log(err);
                this.toasterData = {
                  msg: err.response.data.message,
                  color: "#E51C24",
                  iconName: "close",
                };
                this.isToasterData = true;
                this.loading = false;
              }
            });
        } else {
          this.loading = false;
        }
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
          JSBridgePlugin.addCookiesOn("https://www.mall91.com/#/");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
  },
  mounted() {
    // this.isAdsAvailable()
    // this.cartSize.cartSize = 0
    if (this.addToCart) {
      this.addToCart = false;
    }
    // this.getHotDealOfTheDay()
    var _this = this;
    this.saleReferenceID = this.allDetails.sellerItemRelationshipId;
    this.allDetails = this.dataValue;

    if (this.allDetails) {
      if (this.allDetails.dealDisplayMessage) {
        this.isShowSnackbar = false;
      } else {
        this.isShowSnackbar = true;
      }
      this.categoryId = this.allDetails.categoryId;
      this.buttonMsg = `${this.allDetails.onlineDiscount} ₹​ अतिरिक्त छूट`;
    }
  },
};
</script>
<style scoped lang="scss">
// #hotItemAdded {
//   visibility: hidden;
//   min-width: 250px;
//   margin-left: -125px;
//   background-color: #333;
//   color: #fff;
//   text-align: center;
//   border-radius: 2px;
//   padding: 16px;
//   position: fixed;
//   z-index: 99;
//   left: 50%;
//   bottom: 30px;
//   font-size: 17px;
// }

// #hotItemAdded.show {
//   visibility: visible;
//   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
//   animation: fadein 0.5s, fadeout 0.5s 2.5s;
// }

// @-webkit-keyframes fadein {
//   from {bottom: 0; opacity: 0;}
//   to {bottom: 30px; opacity: 1;}
// }

// @keyframes fadein {
//   from {bottom: 0; opacity: 0;}
//   to {bottom: 30px; opacity: 1;}
// }

// @-webkit-keyframes fadeout {
//   from {bottom: 30px; opacity: 1;}
//   to {bottom: 0; opacity: 0;}
// }

// @keyframes fadeout {
//   from {bottom: 30px; opacity: 1;}
//   to {bottom: 0; opacity: 0;}
// }
.price-block {
  flex-direction: column;
  align-items: flex-start !important;
  -webkit-box-align: left !important;
}
.old-price {
  margin-left: 0 !important;
}
.product_detail_page .limited_offer {
  position: fixed;
  width: 96%;
  bottom: 50px;
  z-index: 10;
  top: auto;
  margin: 4px 2%;
  border-radius: 5px;
  justify-content: space-between;
  padding: 5px 12px;
  overflow: inherit;
  &::before {
    content: "";
    position: absolute;
    width: 15px;
    height: 15px;
    // background: green;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;

    border-top: 10px solid #008000;
    bottom: -10px;
    z-index: 99;
    left: 50%;
    transform: translateX(-50%);
  }
  .msg_offer_time {
    position: relative;
    padding-left: 8px;
    &::before {
      content: "";
      width: 5px;
      height: 5px;
      background: #fff;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
    }
  }
}
.order_button .large_group_btn {
  padding: 18px 15px;
}
.order_button .large_group_btn.group {
  background: red !important;
  padding: 7px 15px;
  font-size: 1.2em;
  font-weight: 600;
  margin: 8px 0 8px 20px;
  border-radius: 5px;
  width: 70%;
}
.order_button .large_group_btn span {
  font-size: inherit;
}
.new_buy_button {
  background: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 15px;
  max-width: 767px;
  margin-right: auto;
  margin-left: auto;
  div {
    // display: flex;
    // align-items: center;
  }
  span {
    strike {
      font-size: 0.875em;
      // padding-left: 8px;
      // font-size: 1.5em;
      color: #727272;
    }
    &.price {
      // color: red;
      font-weight: 500;
      margin: 0 12px;
      margin-left: 0;
      display: inline-flex;
      font-size: 1.5em;
    }
    &.ruppee-sign {
      font-weight: normal;
      font-size: 1em;
      padding-right: 2px;
    }
  }
}
.deal-item-added {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
